export default "https://cdn-static.gokick.com/assets/21dc595b281e80327dab5b97c944977d2420b47e/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";